import { ExtractPercentileNumber } from './types';

const extractPercentileNumber: ExtractPercentileNumber = label => {
  const match = /\d+/.exec(label);

  return parseInt(match ? match[0] : '0', 10);
};

export default extractPercentileNumber;
